import { breakpoint } from 'utility/constant';
import styles from './ButtonField.module.scss';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';

export type ButtonFieldProps = {
  label: string;
  onClick: () => void;
  isInColumn: boolean;
  internalClassName?: string;
};

export const ButtonField = (props: ButtonFieldProps) => {
  const { label, onClick, internalClassName } = props;

  const { doCheck } = useWindowSize();
  const [isMobile] = doCheck([{ comparer: enComparer.less, size: breakpoint.sm }]);

  return (
    <button
      className={`${isMobile || props.isInColumn ? styles.containerMobile : styles.container} ${
        internalClassName ? styles[internalClassName] : ''
      }`}
      onClick={onClick}
    >
      {label}
    </button>
  );
};
